import React, { useState, useEffect } from "react";
import './assets/css/tailwind.css';
import './assets/scss/tailwind.scss';
import './assets/scss/icons.scss';

import { Route, Routes, useNavigate } from "react-router-dom";
import AcademyDetail from "./pages/academy-detail.js";
import HomePage from "./pages/home-page.js";
import Login from './pages/auth/login';
import Signup from './pages/auth/signup';
import ResetPassword from './pages/auth/reset-password';
import Loader from "./component/Loader";
import PortfolioDetail from "./pages/portfolio-detail.js";
import AboutUs from "./pages/about-us.js";
import Navbar from "./component/navbar.js";
import Switcher from "./component/Switcher.js";
import Footer from "./component/Footer.js";
import OurTeamComponent from "./pages/team.js";
import ProductsComponent from "./pages/product.js";
import LearningAndInsights from "./pages/learning-insights.js";
import NewsDetail from "./pages/newsdetails.js";
import BlogDetail from "./pages/blogdetails.js";
import CaseStudyDetail from "./pages/casestudydetail.js";
import AdminLogin from "./pages/adminlogin.js";
import ContactUs from "./pages/contact-us.js";

export default function App() {
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.setAttribute('dir', 'ltr');

    const token = localStorage.getItem("Editor_token");
    setIsAdmin(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("Editor_token");
    setIsAdmin(false);
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* NAVBAR */}
      <Navbar navdark={true} isAdmin={isAdmin} onLogout={handleLogout} />

      {loading && <Loader />}

      {/* MAIN CONTENT */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/index-eight" element={<HomePage />} />
          <Route path="/auth-login" element={<Login />} />
          <Route path="/auth-signup" element={<Signup />} />
          <Route path="/auth-reset-password" element={<ResetPassword />} />
          <Route path="/blog-detail/:id" element={<BlogDetail />} />
          <Route path="/portfolio-detail" element={<PortfolioDetail />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/academy/:slug" element={<AcademyDetail />} />
          <Route path="/our-team" element={<OurTeamComponent />} />
          <Route path="/products" element={<ProductsComponent />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/case-study/:slug" element={<CaseStudyDetail />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/learning-and-insights" element={<LearningAndInsights />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>

      {/* FOOTER */}
      <Footer />

      {/* SWITCHER */}
      <Switcher />
    </div>
  );
}

